import React, { useEffect } from "react";
import { LoadingSpinner } from "lib/Spinner";
import { doLogout } from "./api/doLogout";

export const LogOut = () => {
  useEffect(() => {
    doLogout();
  }, []);

  return <LoadingSpinner />;
};
